// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__37O5O","col":"CardReaderDesc_col__22_Ls","label":"CardReaderDesc_label__3YQwl"};